import styled from 'styled-components'

// eslint-disable-next-line
export const Header = styled.div`
  text-align: center;
  color: ${props => props.theme.colors.textHeader};
`
